export default {
  namespaced: true,
  state: {
    loans: [],
    // channels: [],
    methods: [],
    activeMethods: [],
  },

  mutations:{
    /**
     * [setChannels description]
     * @param {[type]} state    [description]
     * @param {[type]} channels [description]
     */
    methods(state, methods) {
      state.methods = methods
    },
    /**
     * [activeMethods description]
     * @param  {[type]} state         [description]
     * @param  {[type]} activeMethods [description]
     * @return {[type]}               [description]
     */
    activeMethods(state, activeMethods) {
      state.activeMethods = activeMethods
    },
    setLoans(state, payload) {
      state.loans=payload
    },
  },
  getters:{
    /**
     * [getChannels description]
     * @return {[type]} [description]
     */
    methods(state) {
      return state.methods
    },
    /**
     * [activeMethods description]
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    activeMethods(state) {
      return state.activeMethods
    },
    getLoans (state) {
      return state.loans
    },
  },
  actions: {
    /**
     * [printed_transaction description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} id              [description]
     * @return {[type]}                 [description]
     */
    printed_transaction({commit, getters}, id) {
      return this._vm.$http.get('payments/coop/transaction-document?id='+id, {
        responseType: 'blob'
      }).then(response => {
        // console.log(response)
        return response.data
      })
    },
    /**
     * [get_payments description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @return {[type]}                 [description]
     */
    get_payments({commit, getters}, params) {
      return this._vm.$http.get('payments/member/requests', {params})
        .then(response => response.data)
    },
    /**
     * [send_loan_payment description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @return {[type]}                 [description]
     */
    send_loan_payment({commit, getters}, payload) {
      return this._vm.$http.post('payments/member/send', payload)
        .then(response => {
          return response.data
        })
    },
    /**
     * [get_methods description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @return {[type]}                 [description]
     */
    get_methods({commit, getters}) {
      return this._vm.$http.get('payments/coop/methods')
        .then(response => {
          commit('methods', response.data)
          return response.data
        })
    },
    /**
     * [get_active_methods description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @return {[type]}                 [description]
     */
    get_active_methods({commit, getters}) {
      const methods = getters['activeMethods']
      if(methods.length) {
        return Promise.resolve(methods)
      }
      return this._vm.$http.get('payments/member/methods/active')
        .then(response => {
          commit('activeMethods', response.data)
          return response.data
        })
    },
    /**
     * [disable_method description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} id              [description]
     * @return {[type]}                 [description]
     */
    disable_method({commit, getters}, id) {
      return this._vm.$http.get('payments/coop/method/disable?id='+id)
        .then(response => {
          // commit('methods', response.data)
          return response.data
        })
    },
    /**
     * [enable_method description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} id              [description]
     * @return {[type]}                 [description]
     */
    enable_method({commit, getters}, id) {
      return this._vm.$http.get('payments/coop/method/enable?id='+id)
        .then(response => {
          // commit('methods', response.data)
          return response.data
        })
    },
    /**
     * [method_update description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} payload         [description]
     * @return {[type]}                 [description]
     */
    method_update({commit, getters}, {id, form}) {
      return this._vm.$http.post('payments/coop/method/update?id='+id, form)
        .then(response => {
          return response.data
        })
    }
  },

}